import React from "react";
const Header = () => {
  return (
    <div className="ui one column menu stackable center aligned page grid">
      <div className="column twelve wide">
        <h2>Contact Manager</h2>
      </div>
    </div>
  );
};
export default Header;
